import React, { useEffect, useState } from 'react';
import { isWebPushAllowedHere } from '../utils/device';
import '../styles/install-guide.css';

export default function InstallGuide() {
  return !isWebPushAllowedHere() ? <IOSGuide /> : <NotSupported />;
}

function Header() {
  return (
    <header className="ig-header">
      <img className="ig-logo" src="/pwa/guide/logo-hospital.png" alt="北村皮膚科クリニック" />
    </header>
  );
}

/* ===== iPhone ガイド ===== */
function IOSGuide() {
  const videoSrc = '/pwa/guide/install-ios.mp4';
  const poster   = '/pwa/guide/install-poster.jpg';

  const steps = [
    { img: '/pwa/guide/step1.jpg', title: 'メニューボタン',   desc: '画面下部の「・・・」メニューアイコンをタップ' },
    { img: '/pwa/guide/step2.jpg', title: '共有ボタン',   desc: '画面下部の「共有」アイコンをタップ' },
    { img: '/pwa/guide/step3.jpg', title: '下スクロール', desc: '下方向へスクロール' },
    { img: '/pwa/guide/step4.jpg', title: 'ホーム画面に追加', desc: '一覧から「ホーム画面に追加」をタップ' },
    { img: '/pwa/guide/step5.jpg', title: '追加',         desc: '右上の「追加」をタップで完了' },
  ];

  // ライトボックス
  const [zoomSrc, setZoomSrc] = useState(null);
  useEffect(() => {
    if (!zoomSrc) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => (e.key === 'Escape') && setZoomSrc(null);
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [zoomSrc]);

  return (
    <div className="ig-wrap">
      <Header />
      <h1 className="ig-h1">アプリのインストール方法（iPhone）</h1>
      <p className="ig-lead">ホーム画面に追加すると、アプリのように素早く開けます。</p>

      <div className="ig-videoBox">
        <video src={videoSrc} poster={poster} controls playsInline muted className="ig-video" />
        <div className="ig-caption">※端末・ブラウザによりUIが異なる場合があります</div>
      </div>

      <ol className="ig-steps">
        {steps.map((s, i) => (
          <li key={i} className="ig-stepItem">
            <img
              src={s.img}
              alt={s.title}
              className="ig-stepImg"
              onClick={() => setZoomSrc(s.img)}
              loading="lazy"
            />
            <div>
              <div className="ig-stepTitle">{i + 1}. {s.title}</div>
              <div className="ig-stepDesc">{s.desc}</div>
            </div>
          </li>
        ))}
      </ol>

      {/* ライトボックス */}
      {zoomSrc && (
        <div className="ig-lightbox" onClick={() => setZoomSrc(null)} role="dialog" aria-modal="true">
          <button className="ig-lightbox-close" onClick={() => setZoomSrc(null)}>閉じる</button>
          <img src={zoomSrc} alt="拡大画像" />
        </div>
      )}
    </div>
  );
}

/* ===== 非対応端末（Android / iPad / そのほか） ===== */
function NotSupported() {
  const LINE_URL = 'https://line.me/R/home/public/profile?id=404rczrt';
  return (
    <div className="ig-wrap">
      <Header />
      <h1 className="ig-h1">この端末はアプリ予約対象外です</h1>
      <p className="ig-lead">
        現在、アプリ受付予約は <strong>iPhoneのみ</strong> に対応しています。<br />
        お手数ですが、<a href={LINE_URL} className="ig-link">LINE予約</a>をご利用ください。
      </p>
      <a href={LINE_URL} className="ig-primaryBtn ig-primaryBtn--large">LINE予約を開く</a>
    </div>
  );
}
